module.exports = __webpack_public_path__ + "static/Q3_2023_Investor_Presentation-5f12148a3f6ff66325c9a6f9bc821132.pdf";